<!--
    @Author : Luo
    @Time   : 2020/7/21 11:06
-->
<template>
  <div class="login_container flex_center">
    <div class="login_header">
      <span>{{ title }}</span>
    </div>
    <div class="login_main">
      <div class="input_container input_icon flex_center">
        <div class="input_content">
          <span class="input_icon_container">
            <svg-icon iconClass="icon_user" className="icon_down_style svg_icon_xs color_202"></svg-icon>
          </span>
          <input type="text" placeholder="邮箱/手机号" v-model="user" @input="error_hint = ''" />
        </div>
      </div>
      <div class="input_container input_icon flex_center">
        <div class="input_content">
          <span class="input_icon_container">
            <svg-icon iconClass="icon_user" className="icon_down_style svg_icon_xs color_202"></svg-icon>
          </span>
          <input type="password" placeholder="密码" v-model="pass" @input="error_hint = ''" />
        </div>
      </div>
      <div class="login_error">
        <div class="error_hint">
          <span>{{ error_hint }}</span>
        </div>
      </div>
      <div class="login_submit">
        <div class="btn btn_submit" @click="signIn"><span>登录</span></div>
      </div>
    </div>
    <div class="login_footer pos_absolute">
      <div class="computed_title"><span>Copyright©2017 寄意科技（上海）有限公司</span></div>
      <div class="computed_email"><span>联系邮箱：admin@geetecho.com</span></div>
    </div>
  </div>
</template>

<script>
import { _Ajax } from '@/api/_axios'
import _message from '@/message/index'
import { setStorage } from '../common/common_js'

export default {
  name: 'login',
  data () {
    return {
      title: '用户数据管理后台',
      user: '',
      pass: '',
      error_hint: ''
    }
  },
  methods: {
    signIn: function () {
      let that = this
      that.logoutStatus = false
      _Ajax(
        {
          method: 'post',
          url: '/api/login',
          params: {
            username: that.user,
            password: that.pass
          }
        },
        (res) => {
          if (res.data.code === '200') {
            setStorage.setItem('token', res.data.token)
            that.$router.push(
              {
                path: '/home/date'
              }
            )
          } else {
            that.error_hint = _message.ERR_PASS_ACCOUNT
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    },
    keyCodeEnter: function (e) {
      if (e.keyCode === 13) this.signIn()
    }
  },
  beforeMount: function () {
    setStorage.clear()
  },
  mounted: function () {
    document.addEventListener('keyup', this.keyCodeEnter)
  },
  destroyed: function () {
    document.removeEventListener('keyup', this.keyCodeEnter)
  }
}
</script>

<style scoped>
.login_container {flex-flow: column;height: 80vh}

.login_header {width: 340px;text-align: left}
.login_header span {font-size: 24px;font-weight: 600;color: rgba(48, 48, 48, 1)}

.login_main {margin-top: 84px}
.login_main .input_container:first-of-type {margin-top: 0}
.login_main .input_container {margin-top: 16px}

.input_content {position: relative}
.input_icon_container {position: absolute;left: 15px;top: 12px}
.input_content {background: rgba(255, 255, 255, 1)}
.input_content input {width: 282px;padding: 0 15px 0 43px;height: 40px;line-height: 40px;border: 1px solid rgba(219, 219, 219, 1);box-shadow: 0 0 6px 0 rgba(77, 135, 235, 0);border-radius: 4px;font-size: 14px;font-weight: 500;color: rgba(48, 48, 48, 1)}
.input_content input:focus {border: 1px solid rgba(77, 135, 235, 1);box-shadow: 0 0 6px 0 rgba(77, 135, 235, .5)}
.input_content input::placeholder {font-size: 14px;font-weight: 500;color: rgba(102, 102, 102, 1)}

.login_error {margin-top: 18px;text-align: left;height: 16px}

.login_submit {margin-top: 12px}

.btn {width: 340px;height: 40px;line-height: 40px;border-radius: 4px;cursor: pointer}
.btn span {font-size: 16px;font-weight: 400;color: rgba(255, 255, 255, 1)}

.login_footer {bottom: 41px;left: 50%;transform: translateX(-50%)}
.login_footer span {font-size: 14px;font-weight: 400;color: rgba(144, 144, 144, 1)}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue